import React, { useEffect, useState } from "react";
import axios from "../../EventDownloader";
import Modal from "../../components/UI/Modal/Modal";
import EventOverview from "./EventOverview";
import { useTranslation } from 'react-i18next';

const EventViewer = props => {
    const [loading, setLoading] = useState(true);
    const [eventData, setEventData] = useState([]);
    const [eventR1Data, setR1EventData] = useState([]);
    const [eventR2Data, setR2EventData] = useState([]);

    // eslint-disable-next-line
    const [t, i18n] = useTranslation();

    useEffect(() => {
        axios.get("/files.json").then(
            resp => {
                const data = resp.data.reverse();
                setEventData(
                data.map((filename, idx) => {
                    return <EventOverview key={idx} filename={filename} />
                }));
                setR1EventData(
                    data.map((filename, idx) => {
                        return <EventOverview key={idx} filename={filename.substring(0, filename.length - 5) + "_1.json"} />
                    }));
                setR2EventData(
                    data.map((filename, idx) => {
                        return <EventOverview key={idx} filename={filename.substring(0, filename.length - 5) + "_2.json"} />
                    }));
                setLoading(false);
            }
        ).catch(error => {

        });
    }, []);

    return (
        <>
        <h1>Pokémon Sword & Shield - Raid Event Database</h1>
        <Modal show={loading} />
        <h2>{t("wildareas.2")} Events</h2>
        {eventR2Data}
        <h2>{t("wildareas.1")} Events</h2>
        {eventR1Data}
        <h2>{t("wildareas.0")} Events</h2>
        {eventData}
        </>
        );
}

export default EventViewer;